const NavItems = [
    {title:'HOME' , url:'/'},
    {title:'DESTINATION' , url:'/destination'},
    {title:'CREW' , url:'/crew'},
    {title:'TECHNOLOGY' , url:'/technology'},
];

export default NavItems;